<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<div class="section level2" id="paddling-an-activity-for-all-ages">
<p style="text-align: left; font-family:Garamond; font-weight:bold; letter-spacing:1px; padding-bottom:5px; font-size:17px;">Paddling: An Activity for All Ages</p>
<p style="text-indent:0px;">I’m not young anymore. As a matter of fact, I haven’t been young for a long time. The adventures in my books began when I was in my early fifties. In the last one, I was 75. I’m not telling you this to say that sea kayaking is an old man’s pastime. Rather, I am saying that kayaking and its cousin, canoeing, are activities that can be engaged in by people of all ages and, like tennis, golf, and fishing, paddle sports can be enjoyed well into senior-hood. While I was often the oldest paddler on many of my trips, the paddlers’ ages ranged from the mid-twenties to more than 80.</p>
<p>This illustrates that you do not have to be young to start enjoying paddle sports. You can begin at any age. Whether you only want to paddle a simple recreational kayak around a small, familiar lake or, like me, want to go on multi-day trips in different and exciting places, it’s never too late to start. Find a local outfitter who offers day trips and get started. If you like it, you might someday find yourself sleeping in a Costa Rican Jungle, enjoying the Saguenay Fjord in Quebec, or padding on the Sea of Cortez along the Baja Mexican coast.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1fbf0102